import React from "react";
import Button from "../Button";
import Spacing from "../Spacing";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";

export default function AboutStyle4({
  thumbnailSrc,
  miniTitle,
  title,
  subTitle,
  btnText,
  btnUrl,
  darkMode,
}) {
  const { t } = useTranslation();

  return (
    <div className="cs_about cs_style_1">
      <div className="container">
        <div className="row align-items-center cs_gap_y_40">
          <div className="col-lg-6">
            <div className="cs_about_thumb_no_height">
              <video autoPlay loop muted style={{ width: "100%" }}>
                <source src={thumbnailSrc} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="col-lg-5 offset-lg-1">
            <div className="cs_section_heading cs_style_1">
              <Spacing lg="10" md="5" />
              <p className="cs_fs_34 fs-2 cs_extra_bold mb-0 cs_color_orange_800">
                {title}
              </p>
              <Spacing lg="24" md="24" />
              <div className={`cs_m0 cs_fs_30 ${darkMode ? 'text-white' : 'text-dark'}`}>
                {/* Permitir que subTitle sea un elemento React o texto simple */}
                {typeof subTitle === 'object' ? subTitle : <p>{subTitle}</p>}
              </div>
              <Spacing lg="20" md="20" />
            </div>
          </div>
        </div>
        <a
          href="https://calendly.com/nicolas-rs/new-meeting"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="text-center">
            <Spacing lg="80" md="50" />
            <span className="cs_btn cs_style_1">
              {btnText || t("about.buttonText")}
              <span>
                <i>
                  <Icon icon="fa6-solid:arrow-right" />
                </i>
                <i>
                  <Icon icon="fa6-solid:arrow-right" />
                </i>
              </span>
            </span>
          </div>
        </a>
      </div>
    </div>
  );
}
